import React, { useContext } from 'react'
import { ResponsiveTableRow } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { usePageView } from '@fs/zion-analytics'
import { css } from '@emotion/core'
import { Link } from '@fs/zion-router'
import { DmcResponsiveTable } from '../../common/DmcResponsiveTable'
import { usePageTitle } from '../../app/PageTitleContext'
import { PersonContext } from '../PersonContext'
import { UserLink } from '../../app/Links'
import { getFrontendBaseUrl } from '../../../util/UrlUtil'
import usePersonSources from '../../../hooks/usePersonSources'

const wordBreakAll = css`
  word-break: break-word;
`

export default function PersonSources() {
  usePageView({ page_detail: 'DMConsole:PersonSources' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.person.sources'))
  const { currentPerson } = useContext(PersonContext)
  const personId = currentPerson.id
  const { sources } = usePersonSources(personId)

  if (!sources) {
    return null
  }
  if (sources && sources.length === 0) {
    return <>{t('person.source.noSourcesFound', 'No Sources Found')}</>
  }

  return (
    <DmcResponsiveTable
      id="personSourcesTable"
      totalColumnCount={6}
      atSizeColumns={{
        default: {
          labels: [
            t('person.source.sourceId', 'Source ID'),
            t('person.source.link', 'Link'),
            t('person.source.affected', 'Affected'),
            t('contributor', 'Contributor'),
            t('submitter', 'Submitter'),
            t('changeMessage', 'Change Message'),
          ],
        },
      }}
    >
      {sources.map((row) => {
        return (
          <ResponsiveTableRow
            key={row.sourceId}
            column1={
              <Link
                to={`${getFrontendBaseUrl(true)}/tree/sources/viewedit/${row.sourceId}`}
                target="_blank"
                noScrollTop
              >
                {row.sourceId}
              </Link>
            }
            column2={onClickLink(row.linkUri)}
            column3={splitConclusionTypes(row.affectedConclusionTypes)}
            column4={<UserLink userId={row.contributorId} showId userName={row.contributorName} otherTab />}
            column5={<UserLink userId={row.submitterId} showId userName={row.submitterName} />}
            column6={wrappingText(row.changeMessage)}
          />
        )
      })}
    </DmcResponsiveTable>
  )

  function splitConclusionTypes(conclusionTypes) {
    if (conclusionTypes === null) {
      return null
    }
    const distinctConclusionTypes = [...new Set(conclusionTypes)]
    return (
      <ul>
        {distinctConclusionTypes.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    )
  }
  function onClickLink(uri) {
    return (
      <a css={wordBreakAll} href={uri} target="_blank" rel="noopener noreferrer">
        {uri}
      </a>
    )
  }

  function wrappingText(text) {
    return <span css={wordBreakAll}>{text}</span>
  }
}
